import { Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useEffect, useRef, useState } from 'react';
import bgI from '~/assets/images/bg-login-daily.png';
import imgSectionLeft from '~/assets/images/login-section-left.png';
import banner from '~/assets/images/logo2ins87-1703572268552.png';
import SelectLanguage from '~/Layout/DefaultLayout/SelectLaguages';

import axios from 'axios';
import { baseUrl } from '~/utils/helper';

import './index.scss';
import { Form, Input } from 'antd';
import { instanceNoAuth } from '~/utils/axios';
import { useTranslation } from 'react-i18next';
import { NS } from '~/utils/ns';
function Login({ title }) {
  document.title = title;
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation([NS['ALL']]);
  const [setting, setSetting] = useState({});
  const getSetting = async () => {
    try {
      const res = await instanceNoAuth().get('/setting');
      setSetting(res);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getSetting();
  }, []);

  const handleSubmit = (data) => {
    setIsLoading(true);

    const { username, password, capcha: capchaCheck } = data;

    if (!username || !password || !capchaCheck) return toast.warn(t('1'));
    if (capchaCheck !== capcha) return toast.warn(t('wrongCode'));

    axios
      .post(`${baseUrl}/api/daily/login`, {
        username: username,
        password: password,
      })
      .then(function (response) {
        let status = response.data.status;
        if (status === true) {
          sessionStorage.setItem('auth', response.data.auth);
          // toast.success("Đăng nhập thành công", {
          //   theme: "light",
          // });
          setTimeout(() => {
            window.location.href = '/';
          }, 1500);
          return;
        }
        return toast.error(t(response.data?.errCode));
      })
      .catch(function (error) {
        console.log(error);
        toast.error(t('45'));
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const [capcha, setCapcha] = useState('1234');
  const [color, setColor] = useState('red');

  useEffect(() => {
    function generateCaptcha() {
      const captchaText = Math.floor(Math.random() * 10000)
        .toString()
        .padStart(4, '0');
      setCapcha(captchaText);
    }

    generateCaptcha();

    const colors = ['red', 'blue', 'purple', 'green', 'pink'];
    const randomIndex = Math.floor(Math.random() * colors.length);
    setColor(colors[randomIndex]);
  }, []);
  function generateRandomOffset() {
    return Math.floor(Math.random() * 90 - 10);
  }
  return (
    <div
      className="w-full h-[100dvh] flex justify-center items-center"
      style={{
        background: `url(${bgI}) no-repeat`,
        backgroundSize: '100% 100%',
      }}>
      <div className="flex justify-center items-center mobile:p-2">
        <div
          className="w-[460px] h-[692px] tablet:w-[380px] mobile:hidden rounded-l-[15px] tablet:rounded-lg"
          style={{
            boxShadow: '0 2px 24px 0 rgba(0,0,0,.25)',
          }}>
          <img src={imgSectionLeft} className="w-full" alt="" />
        </div>
        <div
          className="w-[460px] h-[692px] tablet:w-[380px] p-[42px] bg-[#323d66] mobile:h-1/2 mobile:w-full mobile:p-4 rounded-r-[15px] mobile:rounded-md tablet:rounded-lg"
          style={{
            boxShadow: '0 2px 24px 0 rgba(0,0,0,.25)',
            // borderRadius: "0 16px 16px 0",
          }}>
          <div className="flex items-end">
            <img src={`${baseUrl}${setting?.logo_image}`} className="w-full max-h-[150px]" alt="" />
          </div>
          <p
            className="text-[28px] text-white font-semibold mt-[16px] mb-[20px] text-center relative mobile:text-[18px] tablet:text-[16px]"
            style={{ fontFamily: 'PingFangSC-Semibold' }}>
            {/* Hệ thống quản lý đại lý */}
            {t('title')}
            <div className="absolute right-0 top-1/2 -translate-y-1/2 z-50">
              <SelectLanguage />
            </div>
          </p>

          <Form onFinish={handleSubmit} layout="vertical">
            <Form.Item
              name="username"
              label={
                <p className="text-white text-[14px]" style={{ fontFamily: 'PingFangSC-Semibold' }}>
                  {/* Tài khoản */}
                  {t('account')}
                </p>
              }>
              <Input
                type="text"
                className="w-full h-[56px] bg-[#222a47] rounded-[8px]  text-[#fcfafa] font-[400] text-[16px] p-[16px] hover:bg-[#222a47] focus:bg-[#222a47] focus-within:bg-[#222a47]"
                placeholder={t('enterAcc')}
                style={{ fontFamily: 'PingFangSC-Semibold' }}
              />
            </Form.Item>
            <Form.Item
              name="password"
              label={
                <p className="text-white text-[14px]" style={{ fontFamily: 'PingFangSC-Semibold' }}>
                  {t('password')}
                </p>
              }>
              <Input
                type="password"
                className="w-full h-[56px] bg-[#222a47] rounded-[8px]  text-[#fcfafa] font-[400] text-[16px] p-[16px] hover:bg-[#222a47] focus:bg-[#222a47] focus-within:bg-[#222a47]"
                placeholder={t('enterPass')}
                style={{ fontFamily: 'PingFangSC-Semibold' }}
                // onChange={e => setPassword(e.target.value)}
              />
            </Form.Item>
            <Form.Item
              name="capcha"
              label={
                <p className="text-white text-[14px]" style={{ fontFamily: 'PingFangSC-Semibold' }}>
                  {t('code')}
                </p>
              }>
              <div className="flex items-center gap-2 ">
                <Input
                  className="mt-[10px] w-[50%] h-[56px] bg-[#222a47] rounded-[8px] mb-[24px] text-[#fcfafa] font-[400] text-[16px] p-[16px] hover:bg-[#222a47] focus:bg-[#222a47] focus-within:bg-[#222a47]"
                  placeholder={t('enterCode')}
                  style={{ fontFamily: 'PingFangSC-Semibold' }}
                />
                <div className="w-[50%] h-[56px]  bg-[#fcfafa] rounded-[8px] mb-[24px] mt-[10px] relative capcha text-center text-[40px] flex gap-3 items-center justify-center">
                  {capcha.split('').map((char, index) => (
                    <span
                      key={index}
                      style={{
                        transform: `rotate(${generateRandomOffset()}deg)`,
                        fontFamily: 'PingFangSC-Semibold',
                        color: color,
                      }}
                      className="rotate font-semibold">
                      {char}
                    </span>
                  ))}
                </div>
              </div>
            </Form.Item>

            <button
              type="submit"
              className="text-[16px] w-full text-center text-white rounded-[8px] h-[56px] flex items-center justify-center cursor-pointer mt-[-20px] disabled:opacity-65"
              style={{
                background: 'linear-gradient(135deg,#7146FF 0%,#4A69FF 100%)',
              }}
              disabled={isLoading}>
              {t('login')}
            </button>
          </Form>
        </div>
      </div>
    </div>
  );
}

export default Login;
